// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { createDigitalIdSession, type CreateSessionRequest } from '../digitalCredentialsClient';
import type { DigitalIdSession } from '../../models/digitalId';

export const useCreateDigitalIdSessionMutation = (options: {
  onSuccess: (session: DigitalIdSession) => void;
}) => {
  const [apiError, setApiError] = useState<{ status: number; body?: unknown } | null>(null);
  const mutation = useMutation({
    mutationFn: (request: CreateSessionRequest) => createDigitalIdSession(request),
    onSuccess: options.onSuccess,
    onError: (error: { status: number; body?: unknown }) => setApiError(error),
  });
  return {
    createSession: mutation.mutate,
    isLoading: mutation.isPending,
    apiError,
    resetApiError: () => setApiError(null),
  };
};
